import { render, staticRenderFns } from "./ZoneToZonePricing.vue?vue&type=template&id=4c9c59f9"
import script from "./ZoneToZonePricing.vue?vue&type=script&lang=js"
export * from "./ZoneToZonePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports